import React from "react";
import Page from "../components/Page";

const AboutPage = () => {
  return <Page>About Page</Page>;
};

export default AboutPage;
